// extracted by mini-css-extract-plugin
export var arrow = "DesktopMenu-module--arrow--8e26e";
export var callout = "DesktopMenu-module--callout--919a0";
export var calloutDescription = "DesktopMenu-module--callout-description--b754c";
export var calloutTitle = "DesktopMenu-module--callout-title--617da";
export var callouts = "DesktopMenu-module--callouts--200f3";
export var columnHeader = "DesktopMenu-module--column-header--9aa74";
export var columnTitle = "DesktopMenu-module--column-title--c5ead";
export var columns = "DesktopMenu-module--columns--e8c51";
export var desktopMenu = "DesktopMenu-module--desktop-menu--0a759";
export var emerald = "DesktopMenu-module--emerald--b9873";
export var evergreen = "DesktopMenu-module--evergreen--f97ef";
export var fadeIn = "DesktopMenu-module--fadeIn--76ccc";
export var gradient = "DesktopMenu-module--gradient--64519";
export var label = "DesktopMenu-module--label--60041";
export var lilac = "DesktopMenu-module--lilac--21044";
export var pink = "DesktopMenu-module--pink--20cf5";
export var primaryItem = "DesktopMenu-module--primary-item--acad7";
export var submenu = "DesktopMenu-module--submenu--5468d";
export var submenuList = "DesktopMenu-module--submenu-list--5032a";